// extracted by mini-css-extract-plugin
module.exports = {"emptyCart":"EmptyCart_emptyCart__6uY0T","startShoppingButton":"EmptyCart_startShoppingButton__sf0fU"};